<template>
	<div class="hris-page">
		<div class="hris-page-inner">
			<div class="hris-page-header">
				<span class="hris-page-eyebrow">Government &amp; Payroll Reports</span>
				<h1 class="hris-page-title">Tax Status</h1>
				<p class="hris-page-subtitle">Manage tax status codes used for withholding tax computation.</p>
			</div>

			<div class="hris-toolbar">
				<div class="hris-toolbar-spacer"></div>
				<q-btn unelevated class="hris-q-primary" label="Create" @click="createCutOff"></q-btn>
			</div>

			<div class="hris-panel">
				<q-table
				:dense="$q.screen.lt.md"
				:grid="$q.screen.xs"
				flat
				title="Tax Status Table"
				:data="generatedData"
				:columns="columns"
				:pagination="initialPagination"
				row-key="id">
				<template v-slot:body="props">
					<q-tr slot="body"  :props="props" @click="selectedRow(props)" style="cursor: pointer;">
						<q-td key="status_code" :props="props">{{ props.row.status_code }}</q-td>
						<q-td key="description" :props="props">{{ props.row.description }}</q-td>
					</q-tr>
				</template>
				<template v-slot:no-data="">
					<div class="hris-empty full-width">
						No Result Found!
					</div>
				</template>
				<template v-slot:top-right>
					<q-btn unelevated class="hris-q-outline" label="Download Excel" style="margin-right: 10px;" no-caps @click="exportTable('xlsx')"></q-btn>
					<q-btn unelevated class="hris-q-outline" label="Download CSV" no-caps @click="exportTable('csv')"></q-btn>
				</template>
			</q-table>
			</div>
		</div>

	<q-dialog v-model="spinner" persistent >
		<q-card class="transparent no-shadow">
			<q-card-section >
				<q-spinner-gears color="green"  size="5.5em"></q-spinner-gears>
			</q-card-section>
		</q-card>
	</q-dialog>

	<q-dialog v-model="addDialog" persistent transition-show="scale">
      	<q-card class="hris-modal">
        	<div class="hris-modal-header">
          		<h3 class="hris-modal-title">Create Tax Status</h3>
        	</div>
        	<div class="hris-modal-body">
				<q-form @submit="onSubmit" class="q-gutter-md">
					<q-input outlined dense color="green" v-model="status_code" label="Status Code" lazy-rules :rules="[ val => val && val.length > 0 || 'Required']"></q-input>
					<q-input outlined dense color="green" v-model="description" label="Description" lazy-rules :rules="[ val => val && val.length > 0 || 'Required']"></q-input>
				  	<div class="hris-modal-footer" style="padding: 0; border-top: none; background: transparent;">
						<q-btn unelevated class="hris-q-ghost" label="Close" type="reset" v-close-popup></q-btn>
						<q-btn unelevated class="hris-q-primary" label="Submit" type="submit"></q-btn>
				  	</div>
				</q-form>
			</div>
      	</q-card>
    </q-dialog>
</div>
</template>

<script>
import axios from 'axios';
import mixins from '../../mixins';
import { exportFile } from 'quasar'
function wrapCsvValue (val, formatFn) {
	let formatted = formatFn !== void 0 ? formatFn(val) : val

	formatted = formatted === void 0 || formatted === null ? '' : String(formatted)

	formatted = formatted.split('"').join('""')
	return `"${formatted}"`
}
export default {
	data () {
		return {
			tempID:0,
			initialPagination: {rowsPerPage: 30},
			addDialog: false,
			yearfilter:new Date().getFullYear(),
			year:new Date().getFullYear(),

			status_code:'',
			description:'',
			yearOptions: [],
			separator:'cell',
			spinner:false,
			generatedData:[],
			data: [],
			columns: [
			{ name: 'status_code', align: 'center', label: 'Status Code', field: 'status_code', sortable: true,  desc:'Status Code' },
			{ name: 'description', align: 'center', label: 'Description', field: 'description', sortable: true,  desc:'Description' },
			],

		}
	},

	created(){
		this.filterData()
		this.yearsList()
	},

	methods: {
		onSubmit () {
			let formData = new FormData();
			formData.append("tempID", this.tempID);
			formData.append("status_code", this.status_code);
			formData.append("description", this.description);
			axios.create({
				baseURL : this.apiUrl,
				headers : {'Authorization' : `Bearer ${this.token}`}
			}).post('/backend/taxstatuses/set',formData)
			.then((res) => {
				this.tempID = 0
				this.onReset()
				this.filterData()
				this.$q.notify({
		          color: 'green-9',
		          textColor: 'white',
		          message: 'Submitted'
		        })
				this.addDialog = false
			});

    	},

		onReset() {
			this.status_code = ''
  		  	this.description = ''
			this.tempID = 0
	    },

		createCutOff: function(){
			this.onReset()
			this.addDialog = true

		},

		selectedRow:function(obj){
			this.status_code = obj.row.status_code,
			this.description = obj.row.description,
			this.tempID = obj.row.id
			this.addDialog = true
		},

		filterData : function(){
			this.spinner = true;
			axios.create({
				baseURL : this.apiUrl,
				headers : {'Authorization' : `Bearer ${this.token}`}
			}).post(`/backend/taxstatuses/table`)
			.then((res) => {
				//console.log(res.data)
				this.generatedData = res.data.data
				this.spinner = false
			});
		},

		yearsList : function(){
			axios.create({
				baseURL : this.apiUrl,
				headers : {'Authorization' : `Bearer ${this.token}`}
			}).post(`/timekeeping/years/list`)
			.then((res) => {
				this.yearOptions = res.data.data
			});
		},

		exportTable:function(fileExtension){

			const content = [ this.columns.map(col => wrapCsvValue(col.label)) ].concat(
			this.generatedData.map(row => this.columns.map(col => wrapCsvValue(
			typeof col.field === 'function'
			? col.field(row)
			: row[col.field === void 0 ? col.name : col.field],
			col.format
			)).join(','))
			).join('\r\n')

			const status =  exportFile(
				`TaxStatusTable.${fileExtension}`,
				content,
				`text/${fileExtension}`
			);

			if (status !== true) {
				this.$q.notify({
					message: 'Browser denied file download...',
					color: 'negative',
					icon: 'warning'
				})
			}
		},
	}
}
</script>
<style lang="css" scoped>
.center{
	text-align:center
}
</style>
<style lang="sass" scoped>
	.my-sticky-column-table
		thead tr:nth-child(2) th:nth-child(2)
			background-color: #fff
		td:nth-child(2)
			background-color: #c1f4cd
		th:nth-child(2)
		td:nth-child(2)
			position: sticky
			left: 0
			z-index: 1
</style>
